import facepaint from "facepaint";

const BREAKPOINTS = [650, 1000, 1350];
const EASEL_BREAKPOINTS = [980, 981];
export const easelMobileBreakpoint = EASEL_BREAKPOINTS[0];

export const mq = facepaint(
  BREAKPOINTS.map((breakpoint) => `@media (min-width: ${breakpoint}px)`),
);

export const easelMq = facepaint(
  EASEL_BREAKPOINTS.map((breakpoint) => `@media (min-width: ${breakpoint}px)`),
);

export const filestackMQ = facepaint(
  [769, 1000].map((breakpoint) => `@media (min-width: ${breakpoint}px)`),
);
